import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export class LU_QM_SourceReference extends StarbaseEntity implements Serializable<LU_QM_SourceReference> {
    public sourceReference: string;
    public uid: number;
    public editable: boolean; // TODO: do we need this here? Isn't this a part of IColumnModel?

    constructor() {
        super();
    }

    public static LuQMSourceReferenceColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Source Reference', 'sourceReference', 'sourceReference', editable, 'string', false, true, 255, true),
            new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, false)
        ];
    }

    public static CreateLuQmSourceReferenceColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Source Reference', 'SourceReference', 'SourceReference', true, 'string', false, true, 255, true)
        ];
    }

    public static setupPrimaryWeaponCollection(collection: LU_QM_SourceReference[]): void {
        of(collection).pipe(
            map((w: LU_QM_SourceReference[]) =>
                w.map((k: LU_QM_SourceReference) => {
                    k = new LU_QM_SourceReference().deserialize(k);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        return Object.assign(new LU_QM_SourceReference(), input);
    }
}
